<template>
  <div class="cats">
    <div class="headings">
      <h2>Our <span class="not-on-mobile">Unique and Common</span> Kitties <span class="not-on-mobile"> - {{ cats.length }} entries</span></h2>
      <h2>Sort by:
        <span v-on:click="sortByUnique()" class="sort" v-bind:class="{ active: uniqueSort }">Unique</span>
        |
        <span v-on:click="sortByCommon()" class="sort" v-bind:class="{ active: commonSort }">Common</span>
    </div>
    <div ref="catref">
      <cat
        v-for="cat in cats"
        :cat="cat"
        >
      </cat>
    </div>
  </div>
</template>


<script>

import Masonry from 'masonry-layout';
import EventEmitter from 'events';

import Cat from './Cat';
import CatRepository from '../../data/CatRepository';

export default {
  components: {
    Cat,
  },

  data() {
    return {
      cats: [],
      uniqueSort: false,
      commonSort: true
    };
  },

  methods: {
    sortByUnique() {
      this.commonSort = false;
      this.uniqueSort = true;

      this.cats = [];

      CatRepository.sortByUnique();
      CatRepository.regrabItems();
    },
    sortByCommon() {
      this.uniqueSort = false;
      this.commonSort = true;

      this.cats = [];

      CatRepository.sortByCommon();
      CatRepository.regrabItems();
    }
  },

  watch: {
    cats: {
      handler() {
        this.$nextTick(() => {
          this.masonry.reloadItems();
          this.masonry.layout();
        });
      },
      deep: true,
    },
  },
  mounted() {

    this.masonry = new Masonry(this.$refs.catref, {
      itemSelector: '.cat',
      gutter: 35,
      percentPosition: true
    });

    CatRepository.on('added', (cat) => {
        this.cats.unshift(cat);
    });

    CatRepository.on('changed', ({ key, title, content }) => {
      const outdatedCat = CatRepository.find(this.cats, key);
      const oldNumber = outdatedCat.number;
      outdatedCat.number = oldNumber + 1;
      this.cats = [];
      CatRepository.regrabItems();
    });

  },
};
</script>

<style>
  .cats {
    flex: 1;
    width: 50%;
  }
  .cats span {
    font-size: 1.5rem;
  }
  .headings {
    display: flex;
    justify-content: space-between;
  }
  .sort:hover {
    cursor: pointer;
    color: #e23942;
  }
  .active {
    color: #e23942;
  }
  h2 {
    color: #41b883;
    font-size: 1.5rem;
    margin-bottom: 1%;
    font-family: Raleway;
    text-transform: uppercase;
  }

  @media(max-width: 980px) {
    h2 {
      font-size: 2.7rem;
    }
    span.sort {
      font-size: 2.7rem;
    }
    .not-on-mobile {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// Index.vue?11d60e62